import classNames from 'classnames';
import dayjs from 'dayjs';
import { FireTwoTone } from '@ant-design/icons';
import { useTheme } from '@insight-health-ai/roseate/theme';
import { Tooltip } from 'antd';

export const DueDate = ({
  date,
  showTime = true,
  breachedBadge,
}: {
  date: string | null;
  showTime?: boolean;
  breachedBadge?: boolean;
}) => {
  const { theme } = useTheme();

  if (!date) {
    return <span className="text-gray-500 italic">Not set</span>;
  }
  const dateObject = dayjs(date);

  const isSameYear = dateObject.isSame(dayjs(), 'year');
  const isPastDate = dateObject.isBefore(dayjs());
  const dateString = isSameYear
    ? dateObject.format('MMM DD')
    : dateObject.format('MMM DD, YYYY');

  const timeString = dateObject.format('hh:mm a');

  return (
    <div className="flex flex-col gap-1">
      <span
        className={classNames('flex items-center gap-1', {
          'text-error': isPastDate,
        })}
      >
        {dateString}
        {breachedBadge && isPastDate && (
          <Tooltip title="Breached">
            <FireTwoTone twoToneColor={theme.colors.danger.DEFAULT} />
          </Tooltip>
        )}
      </span>
      {showTime && (
        <span
          className={classNames('text-xs', {
            'text-fg-muted': !isPastDate,
            'text-error': isPastDate,
          })}
        >
          {timeString}
        </span>
      )}
    </div>
  );
};
